module.exports = __webpack_public_path__ + "2bfbd2b80ca3ebe6d0e20b4eb90e07ef.jpg";